import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Personalizer from 'personalizer';
import AcceptConnection from 'models/connections/AcceptConnection';
import DeleteConnection from 'models/connections/DeleteConnection';
import UserPreference from 'models/user/UserPreference';
import PrivacyAlertModalView from 'views/privacy/PrivacyAlertModalView';
import PrivacyAlertView from 'views/privacy/PrivacyAlertView';
import NavigationUtil from 'utils/NavigationUtil';
import GdprConnectionModalUtil from 'utils/gdpr/GdprConnectionModalUtil';
import templateHtml from 'templates/notification/PendingConnectionItemView.html';
import AnalyticsUtil from 'utils/AnalyticsUtil';
import ConnectionsDispatcher from 'events/ConnectionsDispatcher';
import DateFormatter from 'utils/date/DateFormatter';
import DateParser from 'utils/date/DateParser';

// utils -- userSocialProfileImage
import profileImageHelperV2 from 'utils/userSocialProfileImage/profileImageHelperV2';
import 'utils/userSocialProfileImage/profileImageTypeDefsV2';

var Events = {
    CONNECTION_CLICKED: 'CONNECTION_CLICKED'
};

var PendingConnectionItemView = Backbone.View.extend({
    events: {
        'click .confirm': 'onConfirmButtonClicked',
        'click .delete-btn': 'onDeleteButtonClicked',
        'click .js-select-connection': 'onConnectionClicked',
        'click .mutual-connections-label': 'onMutualConnectionsClicked'
    },

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.pendingConnection = args.pendingConnection;
        this.userProfile = args.userProfile;
        this.userPreferences = args.userPreferences;

        this.openNotificationCallback = args.openNotificationCallback;

        this.profileInfos = args.profileInfos;
    },

    render: function() {
        this.pendingConnection.mutualConnectionLabel =
            this.pendingConnection.mutualConnectionCount > 1 ? 'multiple_mutual_connections' : 'one_mutual_connection';

        const timeStamp =
            this.pendingConnection.requestStartTime &&
            DateFormatter.formatRelativeTime(DateParser.parseISOUTC(this.pendingConnection.requestStartTime));
        this.$el.append(
            this.template({
                Localizer: Localizer,
                Personalizer: Personalizer,
                pendingConnection: this.pendingConnection,
                imageUrl: this.getProfileImageUrl(),
                profileUrl: NavigationUtil.url('/profile/' + this.pendingConnection.displayName),
                timeStamp
            })
        );
        this.$('img.avatar').on('error', (evt) => {
            evt.target.src = profileImageHelperV2.getDefaultProfileImage();
            this.$('img.avatar').css('border-radius', '');
        });
    },

    onConfirmButtonClicked: function(e) {
        e.preventDefault();
        var connectionRequestId = $(e.target).attr('data-id'),
            that = this;

        new UserPreference({
            key: 'GDPR.ProfileActivityVisibility.Dismissed'
        }).fetch({
            success: function(value) {
                if (value.get('value') === 'true') {
                    that.confirmConnection(connectionRequestId);
                } else {
                    GdprConnectionModalUtil.openGdprModal(
                        that.pendingConnection.displayName,
                        connectionRequestId,
                        that,
                        that.openNotificationCallback
                    );
                }
            }
        });
    },

    confirmConnection: function(connectionRequestId) {
        let acceptConnection = new AcceptConnection({
            connectionRequestId: connectionRequestId
        });

        acceptConnection.save(acceptConnection.attributes, {
            success: () => {
                this.enableMessages(true);
                this.privacyAlertView = new PrivacyAlertView({
                    requestType: 'connection'
                });

                this.privacyAlertView.on(PrivacyAlertView.Events.Closed, this.closeModal, this);
                this.privacyAlertView.on(PrivacyAlertView.Events.Ready, this.openModal, this);

                AnalyticsUtil.push({
                    event: 'track_event',
                    category: 'Connection Events',
                    action: 'Accept From Inbox'
                });
            },
            error: (model, response) => this.showConnectionMaxModal(response)
        });
    },

    showConnectionMaxModal: function(response) {
        if (response.status === 400 && response.responseJSON) {
            const errorType = response.responseJSON.errorType;
            if (errorType === 'USER_CONNECTIONS_OVER_LIMIT' || errorType === 'TARGET_CONNECTIONS_OVER_LIMIT') {
                ConnectionsDispatcher.trigger(ConnectionsDispatcher.Events.ON_MAX_CONNECTIONS_MODAL_SHOWED, {
                    isUserConnectionsOverLimitation: errorType === 'USER_CONNECTIONS_OVER_LIMIT',
                    nameToDisplay: this.pendingConnection.fullName || this.pendingConnection.displayName
                });
            }
        }
    },

    openModal: function() {
        if (this.privacyAlertView.getDisplayModal()) {
            this.modalView = new PrivacyAlertModalView({
                view: this.privacyAlertView,
                showFooter: true,
                modalTitle: Localizer.localize('privacy.alert.heading')
            });

            this.modalView.on(PrivacyAlertModalView.Events.ON_SAVE, this.onSavePrivacyClicked, this);
            this.modalView.render();
        }
    },

    closeModal: function() {
        this.modalView.close();
    },

    onSavePrivacyClicked: function() {
        this.privacyAlertView.onSaveClicked();
    },

    onDeleteButtonClicked: function(e) {
        e.preventDefault();

        let deleteConnection = new DeleteConnection({
            connectionRequestId: this.pendingConnection.connectionRequestId
        });

        deleteConnection.save(deleteConnection.attributes, {
            success: () => {
                this.enableMessages(false);

                AnalyticsUtil.push({
                    event: 'track_event',
                    category: 'Connection Events',
                    action: 'Reject From Inbox'
                });
            }
        });
    },

    enableMessages: function(confirm) {
        if (confirm) {
            this.$('.js-confirm-msg').show();
            this.$('.js-delete-msg').hide();
        } else {
            this.$('.js-confirm-msg').hide();
            this.$('.js-delete-msg').show();
        }
        this.$('.confirm').hide();
        this.$('.delete-btn').hide();
    },

    onConnectionClicked: function(e) {
        var url = '/profile/' + this.pendingConnection.displayName;
        this.trigger(Events.CONNECTION_CLICKED);
        NavigationUtil.navigate(url, e);
    },

    onMutualConnectionsClicked: function(e) {
        e.preventDefault();
        ConnectionsDispatcher.trigger(ConnectionsDispatcher.Events.ON_MUTUAL_CONNECTIONS_MODAL_SHOWED, {
            displayName: this.pendingConnection.displayName,
            mutualConnectionsCount: this.pendingConnection.mutualConnectionCount
        });
    },

    getProfileImageUrl: function() {
        const userId = this.pendingConnection?.userId;
        const fallbackUrl = this.pendingConnection?.profileImageUrlSmall;
        /**
         * @type {SimplePublicSocialProfileV2DTO}
         */
        const dto = this.profileInfos?.[userId];
        return profileImageHelperV2.getDtoSmallIconImage(dto, fallbackUrl);
    }
});

PendingConnectionItemView.Events = Events;
export default PendingConnectionItemView;
